<div id="wrapper">
  <div class="d-flex flex-column" id="content-wrapper">
    <div class="container-fluid">
      <div class="user-profile-content">
        <div class="ui-g align-justify">
          <div class="ui-g-12 form-main-body">
            <div class="ui-g form-body">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
                <div class="ui-g" id="form-body-column-1">
                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
                    <div class="main-content" *ngIf="'app.calendar-settings' | translate">
                      <div class="ui-g component-container" *ngIf="technicianApplication && !submitted">
                        <div
                          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align"
                          *ngIf="
                            technicianApplication && technicianApplication.status && technicianApplication.status === userStatus['REVOKED']
                          ">
                          <h4 class="section-title">{{ technicianApplication.reasonDescription }}</h4>
                        </div>

                        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-12 form-column">
                          <app-concession-company-data
                            [autosave]="true"
                            [companyId]="companyId"
                            (companyCreated)="saveNewCompany($event)"></app-concession-company-data>
                        </div>

                        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-12 form-column">
                          <app-concession-technician-data [technicianId]="technicianId" [autosave]="true"></app-concession-technician-data>
                        </div>

                        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
                          <app-data-concession-validation
                            [scenario]="dataConcessionScenario"
                            [initialValue]="concessionValidationInitial"
                            [firstName]="technicianDataFG.controls.first_name.value"
                            [lastName]="technicianDataFG.controls.last_name.value"
                            (onStatusChange)="updateDataConcessionValidationStatus($event)"></app-data-concession-validation>
                        </div>

                        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" [formGroup]="checkDataFG">
                          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" *ngIf="enabledRadioButtons()">
                            <app-file
                              *ngIf="enableHeatingWeldingCertificateConfirmation()"
                              [documents]="documents"
                              [fileType]="'welding_certificate_confirmation_not_required'"
                              (fileEvent)="fileEvent()"
                              [taId]="technicianApplicationId"
                              [uploadDisabled]="companyExist"></app-file>
                          </div>
                        </div>

                        <app-concession-files
                          *ngIf="technicianApplication && concessionManagementDataValidationForm"
                          [dataConcessionScenario]="dataConcessionScenario"
                          [technicianId]="technicianId"
                          [technicianApplication]="technicianApplication"
                          [autosave]="true"></app-concession-files>

                        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column submit-margin margin-top-align">
                          <div class="ui-g-12 margin-align text-center">
                            <button
                              pButton
                              type="button"
                              icon="pi pi-check"
                              iconPos="left"
                              (click)="saveForm()"
                              [disabled]="isDisableSaveForm()"
                              [label]="'basic-profile.fields.send_request' | translate"></button>
                          </div>
                        </div>
                      </div>
                      <div class="ui-g component-container" *ngIf="submitted">
                        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
                          <h4
                            class="section-title"
                            *ngIf="
                              technicianApplication &&
                              technicianApplication.status &&
                              (technicianApplication.status === userStatus['SUBMITTED'] ||
                                technicianApplication.status === userStatus['PARTIALLY_ISSUED'])
                            ">
                            {{ 'basic-profile.fields.concession-application-pending' | translate }}
                          </h4>
                          <h4
                            class="section-title"
                            *ngIf="
                              technicianApplication &&
                              technicianApplication.status &&
                              (technicianApplication.status === userStatus['GRANTED'] ||
                                technicianApplication.status === userStatus['ISSUED'])
                            ">
                            {{ 'basic-profile.fields.concession-application-granted' | translate }}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
